__turbopack_context__.v({
  "bounceIn": "SnsEventSection-module-scss-module__y59nHW__bounceIn",
  "fadeIn": "SnsEventSection-module-scss-module__y59nHW__fadeIn",
  "float1": "SnsEventSection-module-scss-module__y59nHW__float1",
  "float2": "SnsEventSection-module-scss-module__y59nHW__float2",
});
